import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/statics/png/stores/download_on_the_app_store.png'
import _imports_1 from '@/statics/png/stores/get_it_on_google_play.png'


const _hoisted_1 = {
  key: 0,
  class: "flex flex-col items-center justify-center mb-2 py-4 rounded-md"
}
const _hoisted_2 = { class: "mb-2 font-sourcesanspro-regular text-base2 text-white" }
const _hoisted_3 = { class: "flex items-center justify-evenly w-full" }

import { Capacitor } from '@capacitor/core';
import { Browser } from '@capacitor/browser';
import { useI18n } from 'vue-i18n';

import useTenant from '@/shared/composables/useTenant';

// Init

export default /*@__PURE__*/_defineComponent({
  __name: 'InstallApp',
  setup(__props) {

const { t } = useI18n();
const { getTenantConfigAndStyles } = useTenant();
const { tenantConfig } = getTenantConfigAndStyles();

const openLink = (appPlatform: string) => {
	if (appPlatform == 'android') {
		Browser.open({ url: tenantConfig.value!.native_url_android });
	}

	if (appPlatform == 'ios') {
		Browser.open({ url: tenantConfig.value!.native_url_apple });
	}
};

return (_ctx: any,_cache: any) => {
  return (!_unref(Capacitor).isNativePlatform())
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(t)('components.install_app.get_the_app')), 1),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("img", {
            class: "w-[140px]",
            role: "button",
            src: _imports_0,
            onClick: _cache[0] || (_cache[0] = ($event: any) => (openLink('ios')))
          }),
          _createElementVNode("img", {
            class: "w-[140px]",
            role: "button",
            src: _imports_1,
            onClick: _cache[1] || (_cache[1] = ($event: any) => (openLink('android')))
          })
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})